"use client";

import { Stub } from "@/composites/_internal";

/**
 * STUB — replaced in a subsequent ticket. See `docs/PDP_ARCHITECTURE.md`
 *
 * Intent: Cross-page product tile (image + name + price + rating + AddToCart). Used in cross-sells, paired-products, search/PLP, category, recipe-related.
 */
export function ProductCard() {
	return (
		<Stub
			name="product/ProductCard"
			intent="Cross-page product tile (image + name + price + rating + AddToCart). Used in cross-sells, paired-products, search/PLP, category, recipe-related."
		/>
	);
}
